import React, { useMemo } from 'react'
import * as Article from 'components/ArticleComponents'
import { NoTableIcon, YesTableIcon } from '../../templates/PaymentMethod/components/TableIcons'
import styled from 'styled-components'
import { typography } from '@primer-io/goat'

const TableIcon = ({ value }) => {
	switch (value.toLowerCase()) {
		case 'yes':
			return YesTableIcon
		case 'no':
			return NoTableIcon
	}
}

const Table = styled(Article.HorizontalScrollTable)`
	th {
		min-width: 80px;
	}
`

const CompatibilityTd = styled.td`
	min-width: 200px;

	ul {
		list-style: none;
	}

	li {
		display: flex;
		align-items: center;

		& div {
			margin-left: 4px;
			${typography('body-small')}
		}
	}
`

const PaymentMethodTable = ({ data }) => {
	const paymentMethods = useMemo(
		() => Array.from(data).sort((d1, d2) => d1.paymentMethodType.localeCompare(d2.paymentMethodType)),
		[data],
	)

	return (
		<Table>
			<thead>
				<th>Name</th>
				<th>Payment Method Type</th>
				<th>Compatibility</th>
			</thead>

			<tbody>
				{paymentMethods.map(
					({ paymentMethodName, paymentMethodType, webDropIn, webHeadless, mobileDropIn, mobileHeadless }) => (
						<tr key={paymentMethodName}>
							<td>{paymentMethodName}</td>
							<td>
								<code>{paymentMethodType}</code>
							</td>
							<CompatibilityTd>
								<ul>
									<li>
										<TableIcon value={webDropIn} />
										<div>Web Drop-in</div>
									</li>
									<li>
										<TableIcon value={webHeadless} />
										<div>Web Headless</div>
									</li>
									<li>
										<TableIcon value={mobileDropIn} />
										<div>Mobile Drop-in</div>
									</li>
									<li>
										<TableIcon value={mobileHeadless} />
										<div>Mobile Headless</div>
									</li>
								</ul>
							</CompatibilityTd>
						</tr>
					),
				)}
			</tbody>
		</Table>
	)
}

export default PaymentMethodTable
